<template>
    <div class="backend-container">
        <div class="pull-right">
            <a href="/logout">LOG OUT</a>
        </div>
        <h1>Post Deals to Facebook</h1>
        <div><a href="https://www.facebook.com/mymommydeals" target="_blank">Link to Facebook Page</a> <a href="https://www.facebook.com/groups/mymommydeals" target="_blank">Link to Facebook Group</a></div>
        <div>
            <table v-if="deals">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Image</th>
                        <th>Link</th>
                        <th>Title</th>
                        <th>Post</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(deal, index) in deals" v-bind:key="index">
                        <td>
                            {{deal.DealID}}
                        </td>
                        <td>
                            <div class="img-container">
                                <div>
                                    <button @mouseover="deal.showImg = true" @mouseout="deal.showImg = false">IMG</button>
                                </div>
                                <div class="floating" v-show="deal.showImg == true">
                                    <img :src="deal.ImgUrl" class="deal-img" />
                                </div>
                            </div>
                        </td>
                        <td>
                            <a :href="deal.dealLink" target="_blank">LINK TO DEAL</a>
                        </td>
                        <td>
                            <div class="deal-title">{{deal.Title}}</div>
                        </td>
                        <td>
                            <textarea v-model="deal.post" class="post-textarea"></textarea>
                        </td>
                        <td>
                            <div v-show="deal.isBusyPage">
                                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
                            </div>
                            <div v-show="!deal.isBusyPage">
                                <button v-show="!deal.isPostedPage" @click="postToFacebookPage(deal)">Post to Facebook Page</button>
                                <span v-show="deal.isPostedPage"><a href="https://www.facebook.com/mymommydeals" target="_blank">DEAL POSTED on PAGE</a></span>
                            </div>
                        </td>
                        <td>
                            <div v-show="deal.isBusyGroup">
                                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
                            </div>
                            <div v-show="!deal.isBusyGroup">
                                <button v-show="!deal.isPostedGroup" @click="postToFacebookGroup(deal)">Post to Facebook Group</button>
                                <span v-show="deal.isPostedGroup"><a href="https://www.facebook.com/groups/mymommydeals" target="_blank">DEAL POSTED on Group</a></span>
                            </div>
                        </td>
                        <td>
                            <div v-show="deal.isBusyTwitter">
                                <span class="icon"><img src="/Assets/img/spin.svg" /></span>
                            </div>
                            <div v-show="!deal.isBusyTwitter">
                                <button v-show="!deal.isPostedTwitter" @click="postToTwitter(deal)">Post to Twitter</button>
                                <span v-show="deal.isPostedTwitter"><a href="https://twitter.com/MyMommyDeals" target="_blank">DEAL POSTED on Twitter</a></span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import api from '@/api'
    import settings from '@/settings'

    export default {
        name: "home",
        data() {
            return {
                facebookToken: null,
                deals: null
            };
        },
        methods: {
            postToFacebookPage(deal) {
                deal.isBusyPage = true;
                var post = {
                    message: deal.post,
                    imgUrl: deal.ImgUrl,
                    link: deal.dealLink
                };
                api.postToFacebookPage(post).then(response => {
                    window.console.log('response', response);
                    deal.isBusyPage = false;
                    deal.isPostedPage = true;

                    setTimeout(() => {
                        deal.isPostedPage = false;
                    }, 3000);

                });
            },
            postToFacebookGroup(deal) {
                deal.isBusyGroup = true;
                var post = {
                    message: deal.post,
                    imgUrl: deal.ImgUrl,
                    link: deal.dealLink
                };
                api.postToFacebookGroup(post).then(response => {
                    window.console.log('response', response);
                    deal.isBusyGroup = false;
                    deal.isPostedGroup = true;
                    setTimeout(() => {
                        deal.isPostedGroup = false;
                    }, 3000);
                });
            },
            postToTwitter(deal) {
                deal.isBusyTwitter = true;
                var post = {
                    message: deal.post,
                    imgUrl: deal.ImgUrl
                };
                api.postToTwitter(post).then(response => {
                    window.console.log('response', response);
                    deal.isBusyTwitter = false;
                    deal.isPostedTwitter = true;
                    setTimeout(() => {
                        deal.isPostedTwitter = false;
                    }, 3000);
                });
            },
            getDeals() {
                api.getLatestDeals(50, 1, null).then(response => {
                    var deals = response.data;
                    deals.map(d => {

                        let post = `Great Deal! Only $${d.DealPrice}!`;
                        if (d.DealPrice == '-1') {
                            post = `Great Deal!`;
                        }

                        d.post = post;
                        d.showImg = false;
                        d.isBusyPage = false;
                        d.isBusyGroup = false;
                        d.isBusyTwitter = false;
                        d.dealLink = `https://${settings.siteUrl}/deal/${d.DealID}`;
                    });

                    this.deals = deals;


                });
            }
        },
        created() {
            this.getDeals();

        }
    };
</script>
